// extracted by mini-css-extract-plugin
module.exports = {"elementInfo":"ElementInfo_elementInfo__3WnKX","last-child":"ElementInfo_last-child__10wTr","iconWrapper":"ElementInfo_iconWrapper__3VM7V"};